function event_sta(data){
    // total
    event_total_sta(data);
    // detail
    event_detail_sta(data);
}

function event_total_sta(data) {
    var sum = 0, sum_solve = 0, sum_unsolve = 0, tbody_string = '', tfoot_string = '';
    var area_list = {'001': [0,0], '002': [0,0], '003': [0,0], '004': [0,0], '005': [0,0], '009': [0,0], '014': [0,0], '016': [0,0], '017': [0,0], '018': [0,0], '023': [0,0], '024': [0,0], '025': [0,0], '027': [0,0], '029': [0,0], '033': [0,0], '040': [0,0], '041': [0,0], '044': [0,0], '045': [0,0], '046': [0,0], '048': [0,0], '049': [0,0], '050': [0,0], '053': [0,0], '054': [0,0], '057': [0,0], '061': [0,0], '062': [0,0]};
    for (var j = 0; j < 2; j++) {
        for (var i = 0; i < data[j].features.length; i++) {
            sum = sum + 1;
            switch(true){
                case(data[j].features[i].properties.STATUS == 5):
                    sum_solve = sum_solve + 1;
                    area_list[data[j].features[i].properties.TID][0] += 1; 
                    break;
                default:
                    sum_unsolve = sum_unsolve + 1;
                    area_list[data[j].features[i].properties.TID][1] += 1; 
            };
        };
    };
    var thead_string = '<th>行政區</th><th>結案比</th><th>結案數</th><th>未結案數</th>';
    for (var each_area in area_list) {
        var solve_ratio = (area_list[each_area][0] / (area_list[each_area][0] + area_list[each_area][1]))*100;
        if (String(solve_ratio) == "NaN") {
            solve_ratio = 100;
        };
        tbody_string += '<tr>' + 
            '<td>' + condition_area(each_area) + '</td>' +
            '<td>' + solve_ratio.toFixed(0) + '%</td>' +
            '<td>' + area_list[each_area][0] + '</td>' +
            '<td>' + area_list[each_area][1] + '</td>' +
        '</tr>';
    };
    let total_solved_ratio = sum_solve/(sum_solve+sum_unsolve)*100
    tfoot_string = '<tr>' + 
        '<td>總計</td>' +
        '<td>' + total_solved_ratio.toFixed(0) + '%</td>' +
        '<td>' + sum_solve + '</td>' +
        '<td>' + sum_unsolve + '</td>' +
    '</tr>';
    $("#board_phone-call, #live_broadcast_phone-call").html("總計受理災情" + (sum_solve+sum_unsolve) + "件(<ct class='g_text'>已結" + sum_solve + "件</ct>、<ct class='r_text'>未結" + sum_unsolve + "件</ct>)");
    open_data_source('phone-call')
    $("#board_phone-call").siblings("span").find("i").eq(1).click(function(){
        modal_open_table("案件通報統計一覽表", thead_string, tbody_string, 1, tfoot_string);
    });
    $("#board_phone-call").siblings("span").find("i").eq(2).click(function(){
        layer_remove();
        minichart_layer_remove();
        $("#main-2").click();
        backgroud_layer_control("重大災情");
        backgroud_layer_control("一般災情");
        board_auto_fit();
    });    
}

function event_detail_sta(data) {
    var event_all_data_time = [], event_plot_timeseries_data = [];
    $('#event_info_div').html(
        '<div class="row">'+
            '<div class="col-12">'+
                '<h5 class="font-weight-bold mt-2"><i class="fas fa-clock"></i>災情數量時間折線圖</h5>'+
                '<div id="report_total_number_in_series"></div>'+
                '<div class="position-relative">'+
                    '<div class="function-log w-100 h-250" function-log-id="18" id="sta-3-div-1"></div>' +
                '</div>'+
            '</div>'+
            '<div class="col-12">'+
                '<h5 class="font-weight-bold"><i class="fas fa-signal"></i>災情數量行政區長條圖</h5>'+
                '<div class="btn-group mb-2" role="group">'+
                    '<button type="button" class="btn btn-primary btn-sm" id="event_filter_title">目前為全市檢視！</button>'+
                    '<button type="button" class="btn btn-secondary btn-sm" id="event_refilter_trig">重新篩選</button>'+
                '</div>'+        
                '<div class="function-log w-100 h-300" function-log-id="19" id="sta-3-div-2"></div>' +
            '</div>'+    
            '<div class="col-12">'+
                '<h5 class="font-weight-bold"><i class="fas fa-chart-pie"></i>災情類型圓餅圖</h5>'+
                '<div class="position-relative">'+
                    '<div class="function-log w-100 h-400" function-log-id="20" id="sta-3-div-3"></div>' +
                    '<div class="font-weight-bold text-center" id="emis-event-pie-text">目前檢視為<br>全市</div>' +
                '</div>'+
            '</div>'+    
            '<div class="col-12">'+
                '<h5 class="font-weight-bold"><i class="fas fa-table"></i>災情列表</h5>'+
                '<i class="fas fa-map-marker-alt"></i>定位正常；<i class="fas fa-times"></i>無定位'+
                '<table id="event_sta_list" width="100%" height="100%">' +
                    '<thead>' +
                        '<tr>' +
                            '<th>地址</th>' +
                            '<th>EMIS編號</th>' +
                            '<th>嚴重性</th>' +
                            '<th>處理狀態</th>' +
                            '<th>災情類型</th>' +
                            '<th>是否影響交通</th>' +
                        '</tr>' +
                    '</thead>' +
                    '<tbody>' +
                    '</tbody>' +
                '</table>'+
                '<button function-log-id="21" type="button" class="btn btn-success btn-sm btn-block mt-2 function-log" id="event_sta_download">表單下載</button>' +
            '</div>'+
        '</div>'
    );

    $("#event_refilter_trig").click(function(){
        loader_asynchronous(function(){
            if (overlay_dataset["temp_map"] != undefined) {
                map.removeLayer(overlay_dataset["temp_map"]);
            }
            $("#event_filter_title").html('目前為全市檢視！');
            $("#sta-3-div-3").siblings("div").eq(0).html("目前檢視為<br>全市");
            // table_redraw(0, '');
            var chart = $("#sta-3-div-1").highcharts();
            var now_time_data = chart.xAxis;
            map_redraw([], undefined, {min: now_time_data[0].min, max: now_time_data[0].max});
            region_stack_cahrt({min: now_time_data[0].min, max: now_time_data[0].max}, {destroy: true});
            map.setView([25.038169, 121.557588], 11);
            setTimeout(function(){
                map.panBy([-80, 0]);
            }, 1000);
        });
    });

    for (var i = 0; i < 2; i++) {
        data[i].features.forEach(function(element){
            event_all_data_time.push(event_time_processing(element.properties.RPT_TIME));
        });
    };
    var time_min = getMinOfArray(event_all_data_time);
    var time_max = getMaxOfArray(event_all_data_time);
    var hour_length = (time_max - time_min) / 3600000;
    // 補償沒有時間的序列元素
    for (var i = 0; i < hour_length+1; i++) {
        event_all_data_time.push(time_min + (i*3600000));
    }
    // 計算每小時總量
    var event_everyhour_sum = {};
    event_all_data_time.forEach(function(x) { 
        event_everyhour_sum[x] = (event_everyhour_sum[x] || 0 ) +1;
    });
    var time_value;
    for (var i = 0; i < hour_length+1; i++) {
        time_value = time_min + (i*3600000);
        event_plot_timeseries_data.push([time_value, event_everyhour_sum[time_value]-1])
    };

    var event_start, event_end
    event_time_series(false);
    function event_time_series(table_setting){
        var chartType = "area"
        // if (event_plot_timeseries_data.length == 1) { chartType = "column" }
        Highcharts.stockChart('sta-3-div-1', {
            chart: {
                zoomType: 'x',
            },
            yAxis: {
                labels: {
                    style: {
                        fontWeight: 'bold',
                        color: 'rgba(0, 0, 0, 1)',
                        fontSize: '12px'
                    }
                }
            },
            xAxis: {
                dateTimeLabelFormats: {
                    millisecond: '%H:%M:%S',
                    second: '%H:%M:%S',
                    minute: '%H:%M',
                    hour: '%H:%M',
                    day: '%m/%e',
                    week: '%e. %b',
                    month: '%Y/%m',
                    year: '%Y'
                },
                labels: {
                    style: {
                        fontWeight: 'bold',
                        color: 'rgba(0, 0, 0, 1)',
                        fontSize: '12px'
                    }
                },
                events: {
                    setExtremes: function (e) {
                        var time_pick_min = e.min, time_pick_max = e.max;
                        loader_asynchronous(function(){
                            map_redraw([], undefined, {min: time_pick_min, max: time_pick_max});
                            region_stack_cahrt({min: time_pick_min, max: time_pick_max}, {destroy: true});
                            if (overlay_dataset["temp_map"] != undefined) {
                                map.removeLayer(overlay_dataset["temp_map"]);
                            };
                            event_time_series_total_number({
                                "min": time_pick_min, "max": time_pick_max 
                            });
                        });
                    },
                    afterSetExtremes: function (e) {
                        if (e.trigger === 'rangeSelectorButton') {
                            event_start = new Date(e.min).toJSON().slice(0,-1)
                            event_end = new Date(e.max).toJSON().slice(0,-1)
                        }
                    }
                }
            },
            exporting: {
                menuItemDefinitions: {
                    hourSum: {
                        onclick: function () {
                            this.series[0].update({
                                dataGrouping: {
                                    enabled: false
                                }
                            })
                        },
                        text: '統計單元(時)'
                    },
                    daySum: {
                        onclick: function () {
                            this.series[0].update({
                                dataGrouping: {
                                    enabled: true,
                                    forced: true,
                                    units: [
                                        ['day',[1]]
                                    ],
                                }
                            })
                        },
                        text: '統計單元(日)'
                    }
                },
                buttons: {
                    contextButton: {
                        menuItems: ["hourSum", "daySum", "viewFullscreen", "printChart", "downloadPNG", "downloadJPEG", "downloadPDF"]
                    }
                }
            },
            rangeSelector: {
                selected: 4,
                inputEnabled: false,
                buttons: [{
                    type: 'hour',
                    count: 6,
                    text: '近6時'
                }, {
                    type: 'hour',
                    count: 12,
                    text: '近12時'
                }, {
                    type: 'day',
                    count: 1,
                    text: '近24時'
                }, {
                    type: 'day',
                    count: 2,
                    text: '近48時'
                }, {
                    type: 'all',
                    count: 1,
                    text: '全部'
                }],
                buttonTheme: {
                    fill: 'none',
                    stroke: 'none',
                    width: 50,
                    r: 8,
                    style: {
                        color: '#039',
                        fontWeight: 'bold'
                    },
                    states: {
                        hover: {
                        },
                        select: {
                            fill: '#039',
                            style: {
                                color: 'white'
                            }
                        }
                    }
                }
            },
            scrollbar: {
                enabled: false
            },
            navigator: {
                enabled: false
            },
            series: [{
                name: '災害發生數量',
                data: event_plot_timeseries_data,
                type: chartType,
                fillColor: {
                    linearGradient: {
                        x1: 0,
                        y1: 0,
                        x2: 0,
                        y2: 1
                    },
                    stops: [
                        [0, Highcharts.getOptions().colors[0]],
                        [1, Highcharts.Color(Highcharts.getOptions().colors[0]).setOpacity(0).get('rgba')]
                    ]
                }
            }]
        });
        if (table_setting) {
            region_stack_cahrt({min: time_min, max: time_max}, {destroy: true});
        };
        event_time_series_total_number({
            "min": time_min, "max": time_max
        });
    }
    
    function event_time_series_total_number(input){
        if (input.min != Infinity) {
            var sum = 0;
            event_plot_timeseries_data.forEach(function(element){
                if (element[0] >= input.min && element[0] <= input.max) {
                    sum += element[1];
                }
            });
            // var min_string = new Date(input.min).toISOString().slice(0,13), max_string = new Date(input.max).toISOString().slice(5,13);
            var event_time_arr = data[0].features.map(el => el.properties.RPT_TIME)
            function time_format_convert (time) {
                let y = time.slice(0,4)
                let mo = time.slice(4,6)
                let d = time.slice(6,8)
                let h = time.slice(8,10)
                let m = time.slice(10,12)
                let s = time.slice(12,14) 
                return `${y}-${mo}-${d}T${h}:${m}:${s}`
            }
            var defalut_start = time_format_convert(Math.min(...event_time_arr).toString()),
                defalut_end = time_format_convert(Math.max(...event_time_arr).toString())
            event_start = event_start || defalut_start
            event_end = event_end || defalut_end
            $("#report_total_number_in_series").html(
                `<div class="event-filter-by-time mb-1">
                    <span style="font-size:20px" class='d-block'>檢視時間：</span>
                    <input type="datetime-local" id='event-start' value='${event_start}' style='width:210px; margin-right:5px'>
                    <input type="datetime-local" id='event-end' value='${event_end}' style='width:210px; margin-right:5px'>
                    <button type="button" class="btn btn-sm btn-success mb-1" id="event-time-change-search">查詢</button>
                </div>
                <h5>災情總數：<kbd>${sum}</kbd> 筆災情</h5>`
            );

            $('#event-time-change-search').click(function(){
                event_start = $('#event-start').val() + ':00'
                event_end = $('#event-end').val() + ':00'
                var time_pick_min = new Date(event_start).getTime() + 8*60*60*1000, 
                    time_pick_max = new Date(event_end).getTime() + 8*60*60*1000;
                var chart = $("#sta-3-div-1").highcharts()
                chart.xAxis[0].setExtremes(time_pick_min, time_pick_max);
            })


        } else {
            $("#report_total_number_in_series").html("<h5>此專案目前無災情。</h5>");
        }
    }

    region_stack_cahrt({min: time_min, max: time_max}, {destroy: false});

    function region_stack_cahrt(time_setting, table_setting){
        var event_number_object = {}, event_disa_type_object = {}, event_coor_object = {}, disaster_tbody_string = "", each_row_data = [], each_row_data_export = [];
        if (table_setting.destroy) {
            var table = $('#event_sta_list').DataTable();
            table.destroy();
            $("#event_sta_list tbody").empty();
        };
        for (var i = 0; i < 2; i++) {
            data[i].features.forEach(function(element){
                var this_time = event_time_processing(element.properties.RPT_TIME);
                if (this_time >= time_setting.min && this_time <= time_setting.max) {
                    if (event_number_object[condition_area(element.properties.TID)] == undefined) {
                        event_number_object[condition_area(element.properties.TID)] = {"SUM": 0, "FINISH": 0, "UNDO": 0, "NORMAL": 0, "SERIOUS": 0, "DISA_TYPE": {}};
                    }
                    event_number_object[condition_area(element.properties.TID)]["SUM"] += 1;
                    if (element.properties.STATUS == "05") {
                        event_number_object[condition_area(element.properties.TID)]["FINISH"] += 1;
                    } else {
                        event_number_object[condition_area(element.properties.TID)]["UNDO"] += 1;
                    }
                    // if (element.properties.DISA_LEVEL == "1") {
                    //     event_number_object[condition_area(element.properties.TID)]["NORMAL"] += 1;
                    // } else {
                    //     event_number_object[condition_area(element.properties.TID)]["SERIOUS"] += 1;
                    // }

                    // all ntc disa type sta
                    if (event_disa_type_object[condition_disa_type(element.properties.DISA_TYPE)] == undefined) {
                        event_disa_type_object[condition_disa_type(element.properties.DISA_TYPE)] = 0;
                    }            
                    event_disa_type_object[condition_disa_type(element.properties.DISA_TYPE)] += 1;
                    
                    // every region disa type sta
                    if (event_number_object[condition_area(element.properties.TID)]["DISA_TYPE"][condition_disa_type(element.properties.DISA_TYPE)] == undefined) {
                        event_number_object[condition_area(element.properties.TID)]["DISA_TYPE"][condition_disa_type(element.properties.DISA_TYPE)] = 0;
                    }            
                    event_number_object[condition_area(element.properties.TID)]["DISA_TYPE"][condition_disa_type(element.properties.DISA_TYPE)] += 1;

                    var lbs_condition_icon;
                    var lat = parseFloat(element.geometry.coordinates[1]);
                    var lng = parseFloat(element.geometry.coordinates[0]);
                    if (lat == 0 || lng == 0) {
                        lbs_condition_icon = '<i class="fas fa-times"></i>';
                    } else {
                        lbs_condition_icon = '<i class="fas fa-map-marker-alt"></i>';
                    }
                    each_row_data.push([lbs_condition_icon + condition_area(element.properties.TID) + "/" + element.properties.DISA_LOCATION, element.properties.DISA_NO, condition_disa_level(element.properties.DISA_LEVEL), condition_status_type(element.properties.STATUS), condition_disa_type(element.properties.DISA_TYPE),condition_block_traffic(element.properties.TrafficImpact)]);
                    each_row_data_export.push([element.properties.RPT_TIME, condition_area(element.properties.TID), element.properties.DISA_LOCATION, element.properties.DISA_NO, condition_disa_level(element.properties.DISA_LEVEL), condition_status_type(element.properties.STATUS), condition_disa_type(element.properties.DISA_TYPE), lat, lng]);
                    event_coor_object[element.properties.DISA_NO] = [lat, lng];
                }
            })
        };

        // data processing
        var event_Sorted = Object.keys(event_number_object).sort(function(a,b){ return event_number_object[b]["SUM"]-event_number_object[a]["SUM"]});
        var chart_array_finish = [], chart_array_undo = [], chart_array_name = [], chart_array_normal = [], chart_array_serious = [];
        event_Sorted.forEach(function(element){
            chart_array_finish.push(event_number_object[element]["FINISH"]);
            chart_array_undo.push(event_number_object[element]["UNDO"]);
            // chart_array_normal.push(event_number_object[element]["NORMAL"]);
            // chart_array_serious.push(event_number_object[element]["SERIOUS"]);
            chart_array_name.push(element.slice(0,2));
        });

        // pie
        disaster_type_pie(event_disa_type_object, null, {min: time_setting.min, max: time_setting.max});
        // chart
        Highcharts.chart('sta-3-div-2', {
            chart: {
                type: 'column'
            },
            title: {
                text: ''
            },
            xAxis: {
                categories: chart_array_name,
                labels: {
                    step: 1,
                    style: {
                        fontWeight: 'bold',
                        color: 'rgba(0, 0, 0, 1)',
                        fontSize: '16px'
                    },
                    useHTML: true,
                    formatter: function(){
                        var string = this.value.slice(0, 1) + "<br>" + this.value.slice(1, 2)
                        return string;
                    }
                }
            },
            yAxis: {
                min: 0,
                title: {
                    text: ''
                },
                labels: {
                    style: {
                        fontWeight: 'bold',
                        color: 'rgba(0, 0, 0, 1)'
                    }                    
                },
                stackLabels: {
                    enabled: true,
                    style: {
                        fontWeight: 'bold',
                        color: 'rgba(0, 0, 0, 1)'
                    }
                }
            },
            tooltip: {
                headerFormat: '<b>{point.x}</b><br/>',
                pointFormat: '<span style="color:{series.color};">{series.name}</span>: <b>{point.y}件</b> ({point.percentage:.0f}%)<br/>',
                shared: true
            },
            plotOptions: {
                column: {
                    stacking: 'normal',
                    dataLabels: {
                        enabled: false,
                        color: (Highcharts.theme && Highcharts.theme.dataLabelsColor) || 'white'
                    }
                },
                series: {
                    cursor: 'pointer',
                    point: {
                        events: {
                            click: function () {
                                var query_condition = this.category + "區";
                                $("#event_filter_title").html('目前為' + query_condition　+ "檢視！")
                                $("#sta-3-div-3").siblings("div").eq(0).html("目前檢視為<br>" + query_condition);
                                // table
                                table_redraw(0, query_condition);
                                table_redraw(4, '');
                                // chart
                                disaster_type_pie(event_number_object[query_condition]["DISA_TYPE"], query_condition, {min: time_setting.min, max: time_setting.max});
                                // map
                                map_redraw("TID", query_condition, {min: time_setting.min, max: time_setting.max});
                                var target_geojson;
                                overlay_dataset["Basic_map"].features.forEach(function(element){
                                    if (element.properties.TOWNNAME == query_condition) {
                                        target_geojson = element;
                                    }
                                })
                                if (overlay_dataset["temp_map"] != undefined) {
                                    map.removeLayer(overlay_dataset["temp_map"]);
                                }
                                overlay_dataset["temp_map"] = L.geoJson(target_geojson,{
                                    color: "#ef5285",
                                    weight: 3,
                                    fill: false,
                                    interactive: false
                                }).addTo(map);
                                map.fitBounds(overlay_dataset["temp_map"].getBounds());
                                setTimeout(function(){
                                    map.panBy([-90, 0]);
                                }, 500);
                            }
                        }
                    }
                }
            },
            series: [{
                name: '已結案',
                color: 'rgba(58, 197, 105, 1)',
                data: chart_array_finish
            },{
                name: '未結案',
                color: 'rgba(232, 90, 113, 1)',
                data: chart_array_undo
            }]
        });

        // table
        $('#event_sta_list').DataTable({
            "data": each_row_data,
            "deferRender": true,
            "order": [[ 2, "desc" ]],
            "searching": true
        });

        $("#sta-3 tbody").on("click", "tr", function(){
            var coor_array = event_coor_object[$(this).find("td").eq(1).html()];
            map.setView(coor_array, 18);
        });

        $("#event_sta_download").click(function(){
            var now_project_name = $("#now_project_name").html();
            each_row_data_export.unshift(["通報時間", "行政區", "地址", "災情編號", "嚴重性", "處理狀態", "災情類型", "緯度", "經度"]);
            downloadxlsx("災情通報表單_" + now_project_name + ".xlsx", ["災情列表"], [each_row_data_export]);
        });
    }

    function disaster_type_pie(data_input, now_region_filter, now_time_filter){
        var type_Sorted = Object.keys(data_input).sort(function(a,b){ return data_input[b]-data_input[a]});
        var chart_array_disatype = [];
        type_Sorted.forEach(function(element){
            chart_array_disatype.push({
                name: element, 
                y: data_input[element]
            })        
        })
        var pieColors = get_red_color_schema(Object.keys(data_input))
        Highcharts.chart('sta-3-div-3', {
            chart: {
                type: 'pie'
            },
            title: {
                text: ''
            },
            tooltip: {
                useHTML: true,
                headerFormat: '<span class="h5">{point.key}案件</span><br>',
                pointFormat: '{series.name} <b>{point.percentage:.1f}%</b><br>件數： <b>{point.y}件</b>'
            },
            plotOptions: {
                pie: {
                    cursor: 'pointer',
                    colors: pieColors,
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        // format: '<b>{point.name}</b><br>{point.percentage:.1f} %',
                        distance: -20,
                        filter: {
                            property: 'percentage',
                            operator: '>',
                            value: 4
                        },
                        style: {
                            fontWeight: 'bold',
                            fontSize:  '1.2rem'
                        },
                        formatter: function(){
                            var string;
                            string = '<span>' + this.key.slice(0,2) + '<br>占' + this.percentage.toFixed(0) + "%<br>(" + this.y + "筆)</span>";
                            return string;
                        }
                    }
                },
                series: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    point: {
                        events: {
                            click: function(){
                                console.log(this["selected"])
                                switch(this["selected"]){
                                    case(undefined):
                                    case(false):
                                        var query_condition = this.name;
                                        table_redraw(4, query_condition);
                                        map_redraw("DISA_TYPE", [query_condition, now_region_filter], {min: now_time_filter.min, max: now_time_filter.max});
                                        break;
                                    case(true):
                                        if (now_region_filter == null && now_time_filter == null) {
                                            map_redraw([], undefined);
                                        } else if(now_region_filter == null && now_time_filter != null){
                                            map_redraw([], undefined, {min: now_time_filter.min, max: now_time_filter.max});
                                        } else {
                                            map_redraw("TID", now_region_filter, {min: now_time_filter.min, max: now_time_filter.max});
                                        }
                                        table_redraw(4, '');  
                                        break;
                                }
                            }
                        }
                    }
                }
            },
            series: [{
                name: '比例：',
                data: chart_array_disatype
            }]
        })
    }

    function table_redraw(columns_number, query_condition){
        var table = $('#event_sta_list').DataTable();
        table.columns(columns_number).search(query_condition).draw();
    }

    function map_redraw(key_name, query_condition, query_time){
        overlay_dataset["重大災情"].clearLayers();
        map.removeLayer(overlay_dataset["一般災情"]);
        var type = $("#event_plot_div .active").find("input").val(),
            event_marker_layer = event_marker(data, {"key": key_name, "value": query_condition}, query_time, type);
        overlay_dataset["重大災情"] = event_marker_layer[0];
        overlay_dataset["一般災情"] = event_marker_layer[1];
    }
}